(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('ProductList', ProductList);

	ProductList.$inject = [ '$resource' ];

	function ProductList($resource) {
		var resourceUrl = 'api/product-lists/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'update' : {
				method : 'PUT'
			}
		});
	}
})();
